webpackJsonp([1],{

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_charts_MiniBarChart__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'final',
  components: { MiniBarChart: __WEBPACK_IMPORTED_MODULE_0__components_charts_MiniBarChart__["a" /* default */] },
  props: ['brandColor'],
  created: function created() {
    var _this = this;

    var obj = localStorage.getItem('user-data');
    var data = JSON.parse(obj);

    this.avg = [1, 2, 3, 4, 5, 6, 7, 8].reduce(function (p, c) {
      return data['ans_' + c] + p;
    }, 0) / 8;
    if (localStorage.getItem('surveyType') !== 'generic') {
      this.img = this.getObj('company').logo;
    }

    if (this.getObj('surveySubmit') === true) {
      this.surveySubmitted = true;
    }
    var param = 'generic';
    if (localStorage.getItem('surveyType') !== 'generic') {
      param = this.getObj('company').link;
      this.generic = false;
      // param = this.$route.params.link
    }
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://staging.server.employeeconfidence.nz/api" + '/survey/avg/' + localStorage.getItem('surveyType') + '/' + param).then(function (response) {
      _this.globalAvg = response.data.avg;
      localStorage.setItem('globalAvg', _this.globalAvg);
    }).catch(function (e) {
      console.log(e);
    });
  },
  data: function data() {
    return {
      img: '',
      avg: 0,
      globalAvg: 0,
      surveySubmitted: false,
      generic: true,
      pieOptions: {
        tooltips: {
          enabled: false
        },
        responsive: true,
        legend: { display: false },
        animation: {
          duration: 3000
        },
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              max: 10
            }
          }]
        }
      }
    };
  },

  methods: {
    calcAvg: function calcAvg(avg) {
      var surveyType = localStorage.getItem('surveyType');
      if (surveyType === 'customer') {
        return parseFloat((avg * 8).toFixed(2));
      } else {
        return parseFloat(avg.toFixed(2));
      }
    },
    getObj: function getObj(name) {
      var obj = localStorage.getItem(name);
      return JSON.parse(obj);
    },
    backQuestion: function backQuestion() {
      var param = { qno: 1 };
      if (localStorage.getItem('surveyType') !== 'generic') {
        param = { link: this.$route.params.link, qno: 1 };
      }
      this.$router.push({ name: 'question', params: param });
    },
    goNext: function goNext() {
      var surveyType = localStorage.getItem('surveyType');
      var param = { link: this.$route.params.link };
      console.log(surveyType, param);
      if (surveyType === 'generic') {
        this.$router.push('/generic');
      } else if (surveyType === 'customer') {
        this.$router.push('/customer/' + param.link);
      } else {
        this.$router.push('/survey/' + param.link);
      }
    }
  },
  computed: {
    pieData: function pieData() {
      var arr = {
        labels: ['You', 'Market'],
        datasets: [{
          backgroundColor: ['#ef4a47', '#8f2c2b'],
          hoverBorderWidth: 0,
          data: [this.calcAvg(this.avg), this.calcAvg(this.globalAvg)]
        }]
      };
      return arr;
    }
  }
});

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'submit',
  props: ['brandColor'],
  created: function created() {
    console.log(this.$route.params);
    if (localStorage.getItem('surveyType') === 'company' && this.getObj('company')) {
      this.img = this.getObj('company').logo;
    }
  },
  data: function data() {
    return {
      img: ''
    };
  },

  methods: {
    getObj: function getObj(name) {
      var obj = localStorage.getItem(name);
      return JSON.parse(obj);
    },
    backQuestion: function backQuestion() {
      var param = { qno: 1 };
      if (localStorage.getItem('surveyType') !== 'generic') {
        param = { link: this.$route.params.link, qno: 1 };
      }
      this.$router.push({ name: 'question', params: param });
    },
    submitSurvey: function submitSurvey() {
      var _this = this;

      document.getElementById('finish-btn').disabled = true;
      var param = 'generic';
      if (localStorage.getItem('surveyType') !== 'generic') {
        param = this.$route.params.link;
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("https://staging.server.employeeconfidence.nz/api" + '/company/' + param, {
        data: this.getObj('user-data'),
        userDetails: this.getObj('userDetails'),
        surveyType: localStorage.getItem('surveyType')
      }).then(function (response) {
        // JSON responses are automatically parsed.
        // console.log('', response.data)
        localStorage.setItem('surveySubmit', true);
        var param = {};
        if (localStorage.getItem('surveyType') !== 'generic') {
          param = { link: _this.$route.params.link, qno: 1 };
        }
        if (response.data) {
          if (localStorage.getItem('surveyType') === 'customer') {
            _this.$router.push({ name: 'customerfinal', params: param });
          } else {
            _this.$router.push({ name: 'final', params: param });
          }
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
});

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_js_modal__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_js_modal__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_js_modal___default.a);

// Vue.use(Vuetify, {
//   iconfont: 'mdi' // 'md' || 'mdi' || 'fa' || 'fa4'
// })

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var app = document.createElement('div');
app.setAttribute('data-app', true);
document.body.append(app);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_main_css__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_css_main_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import 'vuetify/dist/vuetify.min.css'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      businessLoaded: false,
      NotAValidCompany: false,
      limitFlag: false,
      company: '',
      company_id: '',
      departments: '',
      img: '/static/img/logo.png',
      brandColor: '#EF4A47'
    };
  },

  watch: {
    '$route': function $route(to) {
      if (to.name === 'survey') {
        this.verifyCompany();
      }
    }
  },
  methods: {
    // Detects if device is on iOS
    isIos: function isIos() {
      var userAgent = window.navigator.userAgent.toLowerCase();
      return (/iphone|ipad|ipod/.test(userAgent)
      );
    },

    // Detects if device is in standalone mode
    isInStandaloneMode: function isInStandaloneMode() {
      return 'standalone' in window.navigator && window.navigator.standalone;
    },

    // Emits an event to the question page that will refresh the slider component when the page has finished transitioning. Or else it breaks.
    afterEnter: function afterEnter() {
      this.$emit('refresh-slider');
    },
    movetoRoot: function movetoRoot() {
      this.$router.push({ name: 'Hello' });
    },
    generateCompanyManifest: function generateCompanyManifest(company, routeName) {
      var myDynamicManifest = {
        'name': company.name + ' Pulse',
        'display': 'standalone',
        'orientation': 'portrait',
        'start_url': 'https://staging.survey.employeeconfidence.co.nz/#/' + (routeName === 'survey' ? 'survey' : 'customer') + '/' + company.link,
        'background_color': '#ffffff',
        'theme_color': '#ffffff',
        'icons': [{
          'src': '/static/img/icons/' + company.id + '/android-chrome-192x192.png',
          'sizes': '192x192',
          'type': 'image/png'
        }, {
          'src': '/static/img/icons/' + company.id + '/android-chrome-256x256.png',
          'sizes': '256x256',
          'type': 'image/png'
        }]
      };
      console.log('manifest object', myDynamicManifest);
      return myDynamicManifest;
    },
    updateMenifest: function updateMenifest(company) {
      var manifestUrl;
      // If there is no manifest, use the default manifest
      if (company === 'generic') {
        manifestUrl = '/static/manifest.json';
        document.getElementById('iconSm').setAttribute('href', '/static/img/defaultIcons/favicon-16x16.png');
        document.getElementById('iconLg').setAttribute('href', '/static/img/defaultIcons/favicon-32x32.png');
        document.getElementById('iconApple').setAttribute('href', '/static/img/defaultIcons/apple-touch-icon.png');
      } else {
        var myDynamicManifest = this.generateCompanyManifest(company, this.$route.name);
        var stringManifest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(myDynamicManifest);
        var blob = new Blob([stringManifest], { type: 'application/json' });
        manifestUrl = URL.createObjectURL(blob);
        document.getElementById('iconSm').setAttribute('href', '/static/img/icons/' + company.id + '/favicon-16x16.png');
        document.getElementById('iconLg').setAttribute('href', '/static/img/icons/' + company.id + '/favicon-32x32.png');
        document.getElementById('iconApple').setAttribute('href', '/static/img/icons/' + company.id + '/apple-touch-icon.png');
        // manifestUrl = `/static/manifest-${company.id}-${this.$route.name === 'survey' ? 'company' : 'customer'}.json`
      }
      console.log(manifestUrl);
      document.querySelector('#placeholder-manifest').setAttribute('href', manifestUrl);
      // document.querySelector('link').setAttribute('href', company.logo)
      // e = document.querySelector('link[rel="apple-touch-icon"]') // .setAttribute('href', company.logo)
      // e.setAttribute('href', company.logo)
      // console.log(e)
      // e = document.querySelector('link[rel="mask-icon"]')
      // e.setAttribute('href', company.logo)
      // e = document.querySelector('meta[name="msapplication-TileImage"]')
      // e.setAttribute('href', company.logo)
    },
    verifyCompany: function verifyCompany() {
      var _this = this;

      var link = this.$route.name === 'generic' ? 'generic' : this.$route.params.link;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://staging.server.employeeconfidence.nz/api" + '/company/' + link).then(function (response) {
        _this.businessLoaded = true;
        _this.company = response.data.name;
        _this.company_id = response.data.id;
        _this.departments = response.data.departments;
        _this.img = response.data.logo;
        if (response.data.count >= response.data.limit) {
          _this.limitFlag = true;
        }
        // this.limitFlag = true
        if (response.data.brand_color) _this.brandColor = response.data.brand_color;
        if (_this.$route.params.link !== 'generic') {
          _this.updateMenifest(response.data);
        }
        localStorage.setItem('company', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          name: response.data.name,
          logo: response.data.logo,
          link: response.data.link,
          departments: response.data.departments,
          limitFlag: _this.limitFlag
        }));
        _this.$emit('compnayUpdated');
      }).catch(function (e) {
        _this.businessLoaded = true;
        if (e.response.status === 404) {
          _this.NotAValidCompany = true;
        }
        // If there is no company, use the generic manifest
        _this.updateMenifest('generic');
      });
      if (localStorage.getItem('surveySubmit')) {
        if (localStorage.getItem('surveyType') === 'customer') {
          this.$router.push('/customerfinal/' + (this.$route.params.link ? this.$route.params.link : ''));
        } else {
          this.$router.push('/final/' + (this.$route.params.link ? this.$route.params.link : ''));
        }
      }
    }
  },
  mounted: function mounted() {
    // window.addEventListener('beforeinstallprompt', function (event) {
    //   console.log('before install prompt')
    //   event.prompt()
    // })

    // Checks if should display install popup notification:
    if (this.isIos() && !this.isInStandaloneMode()) {
      // this.setState({ showInstallMessage: true });
      this.$modal.show('install-prompt');
    }
  },
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    var link = this.$route.name === 'generic' ? 'generic' : this.$route.params.link;
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://staging.server.employeeconfidence.nz/api" + '/company/' + link).then(function (response) {
      _this2.businessLoaded = true;
      _this2.company = response.data.name;
      _this2.company_id = response.data.id;
      _this2.departments = response.data.departments;
      _this2.img = response.data.logo;
      if (response.data.count >= response.data.limit) {
        _this2.limitFlag = true;
      }
      // this.limitFlag = true
      if (response.data.brand_color) _this2.brandColor = response.data.brand_color;
      if (_this2.$route.params.link !== 'generic') {
        _this2.updateMenifest(response.data);
      }
      localStorage.setItem('company', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        name: response.data.name,
        logo: response.data.logo,
        link: response.data.link,
        departments: response.data.departments,
        limitFlag: _this2.limitFlag
      }));
      _this2.$emit('compnayUpdated');
    }).catch(function (e) {
      _this2.businessLoaded = true;
      if (e.response.status === 404) {
        _this2.NotAValidCompany = true;
      }
      // If there is no company, use the generic manifest
      _this2.updateMenifest('generic');
    });
    if (localStorage.getItem('surveySubmit')) {
      if (localStorage.getItem('surveyType') === 'customer') {
        this.$router.push('/customerfinal/' + (this.$route.params.link ? this.$route.params.link : ''));
      } else {
        this.$router.push('/final/' + (this.$route.params.link ? this.$route.params.link : ''));
      }
    }
  }
});

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3d6001_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(186);
function injectStyle (ssrContext) {
  __webpack_require__(163)
  __webpack_require__(165)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3d6001_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 163:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 165:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen font-sans antialiased text-grey-darkest leading-normal border-t-8 flex flex-col overflow-hidden",style:({borderColor: _vm.brandColor}),attrs:{"id":"app"}},[(_vm.businessLoaded)?[_c('header',{staticClass:"pt-10 pb-8"},[(_vm.img)?_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"mx-auto block",staticStyle:{"width":"200px"},attrs:{"src":_vm.img}})]):_vm._e()]),_vm._v(" "),_c('main',{staticClass:"flex flex-grow justify-center px-4"},[(_vm.NotAValidCompany)?_c('div',{staticClass:"mx-auto pb-4 px-4"},[_c('p',{staticClass:"mb-3"},[_vm._v("This company could not be found.")]),_vm._v(" "),_c('p',{staticClass:"mb-3"})]):_c('transition',{attrs:{"name":"page-slide-horizontal","mode":"out-in"},on:{"afterEnter":_vm.afterEnter}},[_c('router-view',{attrs:{"company":_vm.company,"img":_vm.img,"brand-color":_vm.brandColor}})],1)],1)]:_vm._e(),_vm._v(" "),_c('footer',{staticClass:"w-full bg-grey-light text-white px-4 p-1"},[_c('div',{staticClass:"container mx-auto flex justify-center"},[_c('button',{staticClass:"text-grey-darker font-bold text-sm",on:{"click":function($event){_vm.$modal.show('privacy-modal')}}},[_vm._v("Privacy")])])]),_vm._v(" "),_c('modal',{attrs:{"name":"install-prompt","pivot-y":0.1,"height":"auto","width":"350","adaptive":true}},[_c('button',{staticClass:"absolute pin-t pin-r p-4",on:{"click":function($event){_vm.$modal.hide('install-prompt')}}},[_c('span',{staticClass:"fal fa-times text-grey-darker"})]),_vm._v(" "),_c('div',{staticClass:"p-4"},[(!_vm.company)?_c('img',{staticClass:"mx-auto block",staticStyle:{"max-width":"150px"},attrs:{"src":_vm.img,"alt":""}}):_c('img',{staticClass:"rounded-lg mx-auto block",staticStyle:{"max-width":"150px"},attrs:{"src":("/static/img/icons/" + _vm.company_id + "/android-chrome-192x192.png"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("\n        Install this application on your home screen to follow your survey results against the market’s in real time.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('p',{staticClass:"text-sm text-grey-darker text-center"},[_vm._v("Just tap\n            "),_c('svg',{staticClass:"inline -mb-1",staticStyle:{"width":"25px","fill":"#1485FF"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50","enable-background":"new 0 0 50 50"}},[_c('path',{attrs:{"d":"M30.3 13.7L25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z"}}),_c('path',{attrs:{"d":"M24 7h2v21h-2z"}}),_c('path',{attrs:{"d":"M35 40H15c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3z"}})]),_vm._v("\n          at bottom of screen then select  "),_c('span',{staticClass:"font-bold"},[_vm._v("Add to Home Screen")]),_vm._v(".\n        ")])])])]),_vm._v(" "),_c('modal',{attrs:{"name":"privacy-modal","pivot-y":0.1,"height":"auto","width":"400","adaptive":true,"scrollable":true}},[_c('button',{staticClass:"absolute pin-t pin-r p-4",on:{"click":function($event){_vm.$modal.hide('privacy-modal')}}},[_c('span',{staticClass:"fal fa-times text-grey-darker"})]),_vm._v(" "),_c('div',{staticClass:"p-4"},[_c('h2',{staticClass:"mb-3 text-lg"},[_vm._v("Confidentiality")]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v("The information you provide will only be used by K3 Consulting Ltd for the purpose specified above. We will not disclose your information to any party outside of this process. The information you provide will be stored securely by K3 Consulting with appropriately restricted access.")]),_vm._v(" "),_c('h2',{staticClass:"mb-3 text-lg"},[_vm._v("Authorisation")]),_vm._v(" "),_c('ol',{staticClass:"mb-3"},[_c('li',[_vm._v("I understand and agree that information collected is personal information and may include sensitive information as defined under The Privacy Act (1993). More information on how we collect, store and manage your personal information is outlined in our Privacy Policy, which can be found here - Privacy & Confidentiality Policy 2020")]),_vm._v(" "),_c('li',[_vm._v("I declare that the information supplied by me will be to the best of my knowledge, true, accurate and complete in all respects. I acknowledge that I will not hold K3 Consulting Ltd responsible for any omission or misstatements, which I have made in the information provided.")]),_vm._v(" "),_c('li',[_vm._v("I confirm that I give permission for the results of this survey to be released to K3 Consulting Ltd.")])]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v("Should you now choose to continue with the survey, please note you are authorizing us to collect, store and manage your personal information, as well as your assessment results.  If you do not wish K3 Consulting to use the results in the above manner, we advise that you should not proceed beyond this point. Please contact us for further discussion as needed.")]),_vm._v(" "),_c('h2',{staticClass:"mb-3 text-lg"},[_vm._v("Contact Us:")]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v("Should you experience any technical difficulties when completing the assessment, please contact K3 Consulting on "),_c('a',{attrs:{"href":"mailto:surveys@k3.co.nz"}},[_vm._v("surveys@k3.co.nz")]),_vm._v(".")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StartSurvey__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Generic__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Question__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Thankyou__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Final__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CustomerFinal__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Submit__ = __webpack_require__(263);




// import CustomerSurvey from '@/components/CustomerSurvey'







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
  }, {
    path: '/generic',
    name: 'generic',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Generic__["a" /* default */]
  },
  // {
  //   path: '/customer/:link',
  //   name: 'customersurvey',
  //   component: CustomerSurvey
  // },
  {
    path: '/survey/:link',
    name: 'survey',
    component: __WEBPACK_IMPORTED_MODULE_3__components_StartSurvey__["a" /* default */]
  }, {
    path: '/question/:link?/:qno',
    name: 'question',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Question__["a" /* default */]
  }, {
    path: '/submit/:link?',
    name: 'submit',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Submit__["a" /* default */]
  }, {
    path: '/final/:link?',
    name: 'final',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Final__["a" /* default */]
  }, {
    path: '/customerfinal/:link?',
    name: 'customerfinal',
    component: __WEBPACK_IMPORTED_MODULE_8__components_CustomerFinal__["a" /* default */]
  }, {
    path: '/thankyou/:link?',
    name: 'thankyou',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Thankyou__["a" /* default */]
  }]
}));

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a266356e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(191);
function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a266356e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 190:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v("K3 Survey Tool")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellat, omnis. Quod incidunt cumque dolorum maxime quam. Debitis voluptatum, sunt quisquam velit, a ab repellat pariatur iusto eveniet est molestiae ullam?")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('img',{staticStyle:{"max-width":"150px","max-height":"150px"},attrs:{"src":"http://www.stickpng.com/assets/images/58429049a6515b1e0ad75ab7.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"headline"},[_vm._v("Employee Surveey")]),_vm._v(" "),_c('div',[_vm._v("Q3 2018")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'survey', params: { link: 'vodafone' }}}},[_vm._v("Start Survey Now")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartSurvey_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09da0428_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartSurvey_vue__ = __webpack_require__(194);
function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartSurvey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09da0428_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartSurvey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 193:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.started)?_c('div',{staticClass:"mx-auto pb-4 px-4"},[_c('p',{staticClass:"mb-3"},[_vm._v("Welcome to the Employee Confidence Pulse Survey!")]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v("This survey will only take you a couple of minutes to complete and has been designed to provide a snapshot of how confident employees are about their organisation’s potential for current and future success.")]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v("Rest assured that your responses will be kept both confidential and secure at all times. Your organisation will only ever be able to see the total result, never an individuals’ responses.")]),_vm._v(" "),_c('p',[_vm._v("Begin the survey to receive your individual results benchmarked against employees from across the country.")]),_vm._v(" "),(_vm.limitFlag)?_c('div',{staticClass:"mt-6 text-center1"},[_c('div',[_c('div',{staticClass:"bg-red-lightest border-l-4 border-red text-red-dark p-4",attrs:{"role":"alert"}},[_c('p',{staticClass:"font-bold"},[_vm._v("This survey has closed.")])])])]):_c('div',{staticClass:"mt-6 text-center"},[_c('button',{staticClass:"mx-2 text-white rounded px-8 py-2 uppercase tracking-wide font-semibold",style:({backgroundColor: _vm.brandColor}),on:{"click":function($event){_vm.started = true}}},[_vm._v("Begin the survey")])])]):_c('form',{staticClass:"mx-auto pb-4",on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit($event)}}},[(_vm.formvalid)?_c('p',[_vm._v("You need to enter some details.")]):_vm._e(),_vm._v(" "),(_vm.alreadyDone)?_c('div',{staticClass:"my-6 text-center1"},[_c('div',[_c('div',{staticClass:"bg-red-lightest border-l-4 border-red text-red-dark p-4",attrs:{"role":"alert"}},[_c('p',{staticClass:"font-bold"},[_vm._v("You have already completed this survey!")])])])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"font-bold text-red mb-4 text-sm"},[_vm._v("Any of the sections below with fewer than five questionnaire responses will not be visible to your employer to ensure your confidentiality.")]),_vm._v(" "),_c('div',{staticClass:"pb-2"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"email"}},[_vm._v("E-mail")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full",attrs:{"id":"email","type":"email","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('p',{staticClass:"text-sm text-grey-darker mb-4"},[_vm._v("*Email address is only used by the survey software to ensure that surveys are only completed once per respondent. Your individual responses are kept confidential and secure and are not visible to employers or anyone else.")])]),_vm._v(" "),_c('fieldset',{staticClass:"pb-6"},[_c('legend',{staticClass:"text-grey-darker text-sm font-medium"},[_vm._v("Gender")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"value":"male","type":"radio","id":"huey","name":"drone","checked":"","required":""},domProps:{"checked":_vm._q(_vm.gender,"male")},on:{"change":function($event){_vm.gender="male"}}}),_vm._v(" "),_c('label',{attrs:{"for":"huey"}},[_vm._v("Male")])]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"value":"female","type":"radio","id":"dewey","name":"drone"},domProps:{"checked":_vm._q(_vm.gender,"female")},on:{"change":function($event){_vm.gender="female"}}}),_vm._v(" "),_c('label',{attrs:{"for":"dewey"}},[_vm._v("Female")])]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"value":"other","type":"radio","id":"louie","name":"drone"},domProps:{"checked":_vm._q(_vm.gender,"other")},on:{"change":function($event){_vm.gender="other"}}}),_vm._v(" "),_c('label',{attrs:{"for":"louie"}},[_vm._v("Prefer to Self Define")])])]),_vm._v(" "),(_vm.gender == 'other')?_c('div',{staticClass:"pb-6"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"otherGender"}},[_vm._v("Other gender")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otherGender),expression:"otherGender"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full",attrs:{"id":"otherGender","type":"text","required":""},domProps:{"value":(_vm.otherGender)},on:{"input":function($event){if($event.target.composing){ return; }_vm.otherGender=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pb-6"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"age"}},[_vm._v("Age")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.age),expression:"age"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full appearance-none",attrs:{"id":"age","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.age=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Please select an option")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("17 or younger.")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("18-24")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("25-34")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("35-44")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("45-54")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("55-64")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("65-74")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("75 or older")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Prefer not to say")])])]),_vm._v(" "),_c('div',{staticClass:"pb-6"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"region"}},[_vm._v("Region")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.region),expression:"region"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full appearance-none",attrs:{"id":"region","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.region=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Please select an option")]),_vm._v(" "),_c('option',{attrs:{"value":"Northland"}},[_vm._v("Northland")]),_vm._v(" "),_c('option',{attrs:{"value":"Auckland"}},[_vm._v("Auckland")]),_vm._v(" "),_c('option',{attrs:{"value":"Waikato"}},[_vm._v("Waikato")]),_vm._v(" "),_c('option',{attrs:{"value":"Bay of Plenty"}},[_vm._v("Bay of Plenty")]),_vm._v(" "),_c('option',{attrs:{"value":"Gisborne"}},[_vm._v("Gisborne")]),_vm._v(" "),_c('option',{attrs:{"value":"Hawke’s Bay"}},[_vm._v("Hawke’s Bay")]),_vm._v(" "),_c('option',{attrs:{"value":"Taranaki"}},[_vm._v("Taranaki")]),_vm._v(" "),_c('option',{attrs:{"value":"Manawatu-Wanganui"}},[_vm._v("Manawatu-Wanganui")]),_vm._v(" "),_c('option',{attrs:{"value":"Wellington"}},[_vm._v("Wellington")]),_vm._v(" "),_c('option',{attrs:{"value":"Nelson-Marlborough"}},[_vm._v("Nelson-Marlborough")]),_vm._v(" "),_c('option',{attrs:{"value":"West Coast"}},[_vm._v("West Coast")]),_vm._v(" "),_c('option',{attrs:{"value":"Canterbury"}},[_vm._v("Canterbury")]),_vm._v(" "),_c('option',{attrs:{"value":"Otago"}},[_vm._v("Otago")]),_vm._v(" "),_c('option',{attrs:{"value":"Southland"}},[_vm._v("Southland")])])]),_vm._v(" "),_c('div',{staticClass:"pb-6"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"tenure"}},[_vm._v("How long have you been with the organisation?")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tenure),expression:"tenure"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full appearance-none",attrs:{"id":"tenure","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tenure=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Please select an option")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Less than 1 Year")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("1 – 2 Years")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("2 - 3 years")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("3 – 5 Years")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5 – 10 Years")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("10 Years+")])])]),_vm._v(" "),_c('div',{staticClass:"pb-6"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"position"}},[_vm._v("Role")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.position),expression:"position"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full appearance-none",attrs:{"id":"position","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.position=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Please select an option")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Senior Management / Executive")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Management / Leadership Role")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Employee")])])]),_vm._v(" "),_c('div',{staticClass:"pb-6"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"department"}},[_vm._v("Department")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.department),expression:"department"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full appearance-none",attrs:{"id":"department","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.department=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Please select an option")]),_vm._v(" "),_vm._l((_vm.departmentList),function(dep,idx){return _c('option',{key:idx,domProps:{"value":dep}},[_vm._v(_vm._s(dep))])})],2)]),_vm._v(" "),_c('button',{staticClass:"mx-2 text-white rounded px-8 py-2 uppercase tracking-wide font-semibold",style:({backgroundColor: _vm.brandColor}),attrs:{"type":"submit"}},[_vm._v("Next")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generic_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_676e2a01_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generic_vue__ = __webpack_require__(197);
function injectStyle (ssrContext) {
  __webpack_require__(196)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Generic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_676e2a01_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Generic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 196:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.started)?_c('div',{staticClass:"mx-auto pb-4 px-4"},[_c('p',{staticClass:"mb-3"},[_vm._v("Welcome to the Employee Confidence Pulse Survey!")]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v("This survey will only take you a couple of minutes to complete and has been designed to provide a snapshot of how confident employees are about their organisation’s potential for current and future success.")]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v("Rest assured that your responses will be kept both confidential and secure at all times.")]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v("Begin the survey to receive your individual results benchmarked against employees from across the country.")]),_vm._v(" "),_c('div',{staticClass:"mt-6 text-center"},[_c('button',{staticClass:"mx-2 text-white rounded px-8 py-2 uppercase tracking-wide font-semibold",style:({backgroundColor: _vm.brandColor}),on:{"click":function($event){_vm.started = true}}},[_vm._v("Begin the survey")])])]):_c('form',{staticClass:"mx-auto pb-4",on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit($event)}}},[(_vm.formvalid)?_c('p',[_vm._v("You need to enter some details.")]):_vm._e(),_vm._v(" "),(_vm.alreadyDone)?_c('div',{staticClass:"my-6 text-center1"},[_c('div',[_c('div',{staticClass:"bg-red-lightest border-l-4 border-red text-red-dark p-4",attrs:{"role":"alert"}},[_c('p',{staticClass:"font-bold"},[_vm._v("You have already completed this survey!")])])])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"font-bold text-red mb-4 text-sm"},[_vm._v("Any of the sections below with fewer than five questionnaire responses will not be visible to your employer to ensure your confidentiality.")]),_vm._v(" "),_c('div',{staticClass:"pb-2"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"email"}},[_vm._v("E-mail")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full",attrs:{"id":"email","type":"email","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('p',{staticClass:"text-sm text-grey-darker mb-4"},[_vm._v("*Email address is only used by the survey software to ensure that surveys are only completed once per respondent. Your individual responses are kept confidential and secure and are not visible to employers or anyone else.")])]),_vm._v(" "),_c('div',{staticClass:"pb-6"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"organisation"}},[_vm._v("Organisation")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.organisation),expression:"organisation"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full",attrs:{"id":"organisation","type":"text","required":""},domProps:{"value":(_vm.organisation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.organisation=$event.target.value}}})]),_vm._v(" "),_c('fieldset',{staticClass:"pb-6"},[_c('legend',{staticClass:"text-grey-darker text-sm font-medium"},[_vm._v("Gender")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"value":"male","type":"radio","id":"huey","name":"drone","checked":""},domProps:{"checked":_vm._q(_vm.gender,"male")},on:{"change":function($event){_vm.gender="male"}}}),_vm._v(" "),_c('label',{attrs:{"for":"huey"}},[_vm._v("Male")])]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"value":"female","type":"radio","id":"dewey","name":"drone"},domProps:{"checked":_vm._q(_vm.gender,"female")},on:{"change":function($event){_vm.gender="female"}}}),_vm._v(" "),_c('label',{attrs:{"for":"dewey"}},[_vm._v("Female")])]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"value":"other","type":"radio","id":"louie","name":"drone"},domProps:{"checked":_vm._q(_vm.gender,"other")},on:{"change":function($event){_vm.gender="other"}}}),_vm._v(" "),_c('label',{attrs:{"for":"louie"}},[_vm._v("Prefer to Self Define")])])]),_vm._v(" "),(_vm.gender == 'other')?_c('div',{staticClass:"pb-6"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"otherGender"}},[_vm._v("Other gender")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otherGender),expression:"otherGender"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full",attrs:{"id":"otherGender","type":"text","required":""},domProps:{"value":(_vm.otherGender)},on:{"input":function($event){if($event.target.composing){ return; }_vm.otherGender=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pb-6"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"age"}},[_vm._v("Age")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.age),expression:"age"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full appearance-none",attrs:{"id":"age","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.age=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Please select an option")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("17 or younger.")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("18-24")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("25-34")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("35-44")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("45-54")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("55-64")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("65-74")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("75 or older")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Prefer not to say")])])]),_vm._v(" "),_c('div',{staticClass:"pb-6"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"region"}},[_vm._v("Region")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.region),expression:"region"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full appearance-none",attrs:{"id":"region","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.region=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Please select an option")]),_vm._v(" "),_c('option',{attrs:{"value":"Northland"}},[_vm._v("Northland")]),_vm._v(" "),_c('option',{attrs:{"value":"Auckland"}},[_vm._v("Auckland")]),_vm._v(" "),_c('option',{attrs:{"value":"Waikato"}},[_vm._v("Waikato")]),_vm._v(" "),_c('option',{attrs:{"value":"Bay of Plenty"}},[_vm._v("Bay of Plenty")]),_vm._v(" "),_c('option',{attrs:{"value":"Gisborne"}},[_vm._v("Gisborne")]),_vm._v(" "),_c('option',{attrs:{"value":"Hawke’s Bay"}},[_vm._v("Hawke’s Bay")]),_vm._v(" "),_c('option',{attrs:{"value":"Taranaki"}},[_vm._v("Taranaki")]),_vm._v(" "),_c('option',{attrs:{"value":"Manawatu-Wanganui"}},[_vm._v("Manawatu-Wanganui")]),_vm._v(" "),_c('option',{attrs:{"value":"Wellington"}},[_vm._v("Wellington")]),_vm._v(" "),_c('option',{attrs:{"value":"Nelson-Marlborough"}},[_vm._v("Nelson-Marlborough")]),_vm._v(" "),_c('option',{attrs:{"value":"West Coast"}},[_vm._v("West Coast")]),_vm._v(" "),_c('option',{attrs:{"value":"Canterbury"}},[_vm._v("Canterbury")]),_vm._v(" "),_c('option',{attrs:{"value":"Otago"}},[_vm._v("Otago")]),_vm._v(" "),_c('option',{attrs:{"value":"Southland"}},[_vm._v("Southland")])])]),_vm._v(" "),_c('div',{staticClass:"pb-6"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"tenure"}},[_vm._v("How long have you been with the organisation?")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tenure),expression:"tenure"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full appearance-none",attrs:{"id":"tenure","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tenure=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Please select an option")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Less than 1 Year")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("1 – 2 Years")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("2 – 3 Years")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("3 – 5 Years")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5 – 10 Years")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("10 Years+")])])]),_vm._v(" "),_c('div',{staticClass:"pb-6"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"position"}},[_vm._v("Role")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.position),expression:"position"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full appearance-none",attrs:{"id":"position","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.position=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Please select an option")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Senior Management / Executive")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Management / Leadership Role")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Employee")])])]),_vm._v(" "),_c('div',{staticClass:"pb-6"},[_c('label',{staticClass:"text-grey-darker text-sm font-medium",attrs:{"for":"department"}},[_vm._v("Department")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.department),expression:"department"}],staticClass:"bg-grey-lighter text-grey-darkest rounded p-2 w-full",attrs:{"placeholder":"IT, workshop etc","id":"department","type":"department","required":""},domProps:{"value":(_vm.department)},on:{"input":function($event){if($event.target.composing){ return; }_vm.department=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"mx-2 text-white rounded px-8 py-2 uppercase tracking-wide font-semibold",style:({backgroundColor: _vm.brandColor}),attrs:{"type":"submit"}},[_vm._v("Next")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0695142_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__ = __webpack_require__(201);
function injectStyle (ssrContext) {
  __webpack_require__(199)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0695142_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 199:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 flex flex-col",staticStyle:{"max-width":"500px"}},[_c('div',{staticClass:"mb-auto"},[_c('transition',{attrs:{"name":"question","mode":"out-in"},on:{"after-enter":_vm.afterEnter}},[_c('div',{key:_vm.qNo},[_c('div',{staticClass:"font-semibold text-lg text-center"},[_vm._v("\n          "+_vm._s(_vm.getQuestion())+"\n        ")]),_vm._v(" "),(_vm.customerSurvey)?_c('div',{staticClass:"w-full flex text-grey-dark text-sm pt-6"},[_c('span',{staticClass:"w-1/3"},[_vm._v("0")]),_vm._v(" "),_c('span',{staticClass:"w-1/3 text-center"},[_vm._v("5")]),_vm._v(" "),_c('span',{staticClass:"w-1/3 text-right"},[_vm._v("10")])]):_c('div',{staticClass:"w-full flex text-grey-dark text-sm pt-6"},[_c('span',{staticClass:"w-1/3"},[_vm._v("Disagree")]),_vm._v(" "),_c('span',{staticClass:"w-1/3 text-center"},[_vm._v("Neutral")]),_vm._v(" "),_c('span',{staticClass:"w-1/3 text-right"},[_vm._v("Agree")])]),_vm._v(" "),_c('div',{staticClass:"employee-confidence-slider"},[_c('vue-slider',_vm._b({ref:"slider",attrs:{"tooltip":"always","tooltip-dir":"bottom","piecewise":true,"piecewiseStyle":{'backgroundColor': '#ccc','width': '4px','height': '4px'}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'vue-slider',_vm.options,false))],1),_vm._v(" "),_c('div',{staticClass:"w-full flex justify-between text-grey-dark text-sm px-2"},[_c('span',[_vm._v("0")]),_vm._v(" "),_c('span',[_vm._v("10")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"question-stagger","mode":"out-in"}},[_c('div',{key:'buttons' + _vm.qNo},[_c('div',{staticClass:"flex justify-center pt-8"},[(_vm.qNo > 1)?_c('button',{staticClass:"mx-2 rounded px-8 py-2 uppercase tracking-wide font-semibold",style:({color: _vm.brandColor}),attrs:{"type":"button"},on:{"click":_vm.backQuestion}},[_vm._v("Back")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"mx-2 text-white rounded px-8 py-2 uppercase tracking-wide font-semibold",style:({backgroundColor: _vm.brandColor}),attrs:{"type":"button"},on:{"click":_vm.nextQuestion}},[_vm._v("Next")])])])])],1),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"text-sm text-grey-dark"},[_c('transition',{attrs:{"name":"number","mode":"out-in"}},[_c('span',{key:_vm.qNo,staticClass:"inline-block"},[_vm._v(_vm._s(_vm.qNo))])]),_vm._v("\n        of "+_vm._s(_vm.maxQuestion)+"\n      ")],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"w-full bg-grey-lighter rounded-full mx-auto",staticStyle:{"max-width":"120px","height":"6px"}},[_c('div',{staticClass:"h-full bg-grey w-1/2 rounded-full",staticStyle:{"transition":"0.2s all","transition-delay":"300"},style:({width:(_vm.progressPercent + "%")})})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Thankyou_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf2e5316_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Thankyou_vue__ = __webpack_require__(204);
function injectStyle (ssrContext) {
  __webpack_require__(203)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Thankyou_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf2e5316_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Thankyou_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full p-4 text-center"},[_c('h1',{staticClass:"text-xl mb-2"},[_vm._v("Thank You for completing the survey.")]),_vm._v(" "),_c('p',[_vm._v("Your answers have been saved.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Final_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b15e8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Final_vue__ = __webpack_require__(259);
function injectStyle (ssrContext) {
  __webpack_require__(206)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Final_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b15e8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Final_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 206:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      msg: 'Demo Survey App'
    };
  }
});

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'startSurvey',
  props: ['company', 'img', 'brandColor'],
  mounted: function mounted() {
    console.log('start survey, emp');
    console.log("https://staging.server.employeeconfidence.nz/api", "production");
    this.$on('compnayUpdated', function () {});
  },
  created: function created() {
    var company = JSON.parse(localStorage.getItem('company'));
    this.limitFlag = company ? company.limitFlag : true;
    if (company && company.departments) {
      this.departmentList = company.departments.split(',');
    }
  },

  data: function data() {
    return {
      started: false,
      limitFlag: false,
      url: '',
      valid: false,
      formvalid: false,
      alreadyDone: false,
      email: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/.+@.+/.test(v) || 'E-mail must be valid'
        );
      }],
      gender: '',
      age: '',
      otherGender: '',
      tenure: '',
      position: '',
      region: '',
      department: '',
      departmentList: [],
      direct: ''
    };
  },
  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      if (this.email) {} else {
        this.formvalid = true;
        return;
      }
      // Submits a custom gender if other was selected
      var computedGender = this.gender === 'other' ? this.otherGender : this.gender;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://staging.server.employeeconfidence.nz/api" + '/company/verify/' + this.$route.params.link, {
        email: this.email,
        age: this.age,
        gender: computedGender,
        position: this.position,
        tenure: this.tenure,
        type: 'company'
      }).then(function (response) {
        // JSON responses are automatically parsed.
        if (!response.data) {
          var def = 5;
          var obj = {
            email: _this.email,
            gender: computedGender,
            age: _this.age,
            position: _this.position,
            region: _this.region,
            department: _this.department,
            tenure: _this.tenure,
            ans_1: def,
            ans_2: def,
            ans_3: def,
            ans_4: def,
            ans_5: def,
            ans_6: def,
            ans_7: def,
            ans_8: def,
            ans_9: def,
            ans_10: def,
            ans_11: def,
            ans_12: def
          };
          localStorage.setItem('user-data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
          localStorage.setItem('surveyType', 'company');
          localStorage.setItem('surveySubmit', false);
          console.log();
          _this.$router.push({ name: 'question', params: { link: _this.$route.params.link, qno: 1 } });
        } else {
          _this.alreadyDone = true;
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
});

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'generic',
  props: ['company', 'img', 'brandColor'],
  beforeCreate: function beforeCreate() {
    this.url = 'https://staging.server.employeeconfidence/api';
    // axios.get(`${this.url}/company/${this.$route.params.link}`)
    //   .then(response => {
    //     this.company = response.data.name
    //     this.img = response.data.logo
    //     localStorage.setItem('company', JSON.stringify({ name: response.data.name, logo: response.data.logo }))
    //   })
    //   .catch(e => {
    //     console.log(e)
    //   })
  },
  mounted: function mounted() {
    console.log("https://staging.server.employeeconfidence.nz/api", "production");
  },

  data: function data() {
    return {
      started: false,
      valid: false,
      formvalid: false,
      alreadyDone: false,
      organisation: '',
      organisationRules: [function (v) {
        return !!v || 'Organisation is required';
      }],
      position: '',
      positionRules: [function (v) {
        return !!v || 'Position is required';
      }],
      tenure: '',
      tenureRules: [function (v) {
        return !!v || 'Tenure is required';
      }],
      gender: '',
      genderRules: [function (v) {
        return !!v || 'Gender is required';
      }],
      email: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/.+@.+/.test(v) || 'E-mail must be valid'
        );
      }],
      age: '',
      region: '',
      department: ''
    };
  },
  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      if (this.email && this.organisation && this.position && this.tenure && this.gender) {} else {
        this.formvalid = true;
        return;
      }

      var computedGender = this.gender === 'other' ? this.otherGender : this.gender;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://staging.server.employeeconfidence.nz/api" + '/company/verify/generic', {
        email: this.email,
        age: this.age,
        gender: computedGender,
        position: this.position,
        tenure: this.tenure,
        organisation: this.organisation,
        type: 'generic'
      }).then(function (response) {
        // JSON responses are automatically parsed.
        console.log('', response.data);
        if (!response.data) {
          var def = 5;
          var obj = {
            email: _this.email,
            organisation: _this.organisation,
            gender: computedGender,
            age: _this.age,
            position: _this.position,
            region: _this.region,
            department: _this.department,
            tenure: _this.tenure,
            ans_1: def,
            ans_2: def,
            ans_3: def,
            ans_4: def,
            ans_5: def,
            ans_6: def,
            ans_7: def,
            ans_8: def,
            ans_9: def,
            ans_10: def,
            ans_11: def,
            ans_12: def
          };
          localStorage.setItem('user-data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
          localStorage.setItem('surveyType', 'generic');
          localStorage.setItem('surveySubmit', false);
          console.log('route here please', _this.$router);
          _this.$router.push({ name: 'question', params: { qno: 1 } });
        } else {
          _this.alreadyDone = true;
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
});

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 34,
	"./af.js": 34,
	"./ar": 35,
	"./ar-dz": 36,
	"./ar-dz.js": 36,
	"./ar-kw": 37,
	"./ar-kw.js": 37,
	"./ar-ly": 38,
	"./ar-ly.js": 38,
	"./ar-ma": 39,
	"./ar-ma.js": 39,
	"./ar-sa": 40,
	"./ar-sa.js": 40,
	"./ar-tn": 41,
	"./ar-tn.js": 41,
	"./ar.js": 35,
	"./az": 42,
	"./az.js": 42,
	"./be": 43,
	"./be.js": 43,
	"./bg": 44,
	"./bg.js": 44,
	"./bm": 45,
	"./bm.js": 45,
	"./bn": 46,
	"./bn.js": 46,
	"./bo": 47,
	"./bo.js": 47,
	"./br": 48,
	"./br.js": 48,
	"./bs": 49,
	"./bs.js": 49,
	"./ca": 50,
	"./ca.js": 50,
	"./cs": 51,
	"./cs.js": 51,
	"./cv": 52,
	"./cv.js": 52,
	"./cy": 53,
	"./cy.js": 53,
	"./da": 54,
	"./da.js": 54,
	"./de": 55,
	"./de-at": 56,
	"./de-at.js": 56,
	"./de-ch": 57,
	"./de-ch.js": 57,
	"./de.js": 55,
	"./dv": 58,
	"./dv.js": 58,
	"./el": 59,
	"./el.js": 59,
	"./en-au": 60,
	"./en-au.js": 60,
	"./en-ca": 61,
	"./en-ca.js": 61,
	"./en-gb": 62,
	"./en-gb.js": 62,
	"./en-ie": 63,
	"./en-ie.js": 63,
	"./en-il": 64,
	"./en-il.js": 64,
	"./en-nz": 65,
	"./en-nz.js": 65,
	"./eo": 66,
	"./eo.js": 66,
	"./es": 67,
	"./es-do": 68,
	"./es-do.js": 68,
	"./es-us": 69,
	"./es-us.js": 69,
	"./es.js": 67,
	"./et": 70,
	"./et.js": 70,
	"./eu": 71,
	"./eu.js": 71,
	"./fa": 72,
	"./fa.js": 72,
	"./fi": 73,
	"./fi.js": 73,
	"./fo": 74,
	"./fo.js": 74,
	"./fr": 75,
	"./fr-ca": 76,
	"./fr-ca.js": 76,
	"./fr-ch": 77,
	"./fr-ch.js": 77,
	"./fr.js": 75,
	"./fy": 78,
	"./fy.js": 78,
	"./gd": 79,
	"./gd.js": 79,
	"./gl": 80,
	"./gl.js": 80,
	"./gom-latn": 81,
	"./gom-latn.js": 81,
	"./gu": 82,
	"./gu.js": 82,
	"./he": 83,
	"./he.js": 83,
	"./hi": 84,
	"./hi.js": 84,
	"./hr": 85,
	"./hr.js": 85,
	"./hu": 86,
	"./hu.js": 86,
	"./hy-am": 87,
	"./hy-am.js": 87,
	"./id": 88,
	"./id.js": 88,
	"./is": 89,
	"./is.js": 89,
	"./it": 90,
	"./it.js": 90,
	"./ja": 91,
	"./ja.js": 91,
	"./jv": 92,
	"./jv.js": 92,
	"./ka": 93,
	"./ka.js": 93,
	"./kk": 94,
	"./kk.js": 94,
	"./km": 95,
	"./km.js": 95,
	"./kn": 96,
	"./kn.js": 96,
	"./ko": 97,
	"./ko.js": 97,
	"./ky": 98,
	"./ky.js": 98,
	"./lb": 99,
	"./lb.js": 99,
	"./lo": 100,
	"./lo.js": 100,
	"./lt": 101,
	"./lt.js": 101,
	"./lv": 102,
	"./lv.js": 102,
	"./me": 103,
	"./me.js": 103,
	"./mi": 104,
	"./mi.js": 104,
	"./mk": 105,
	"./mk.js": 105,
	"./ml": 106,
	"./ml.js": 106,
	"./mn": 107,
	"./mn.js": 107,
	"./mr": 108,
	"./mr.js": 108,
	"./ms": 109,
	"./ms-my": 110,
	"./ms-my.js": 110,
	"./ms.js": 109,
	"./mt": 111,
	"./mt.js": 111,
	"./my": 112,
	"./my.js": 112,
	"./nb": 113,
	"./nb.js": 113,
	"./ne": 114,
	"./ne.js": 114,
	"./nl": 115,
	"./nl-be": 116,
	"./nl-be.js": 116,
	"./nl.js": 115,
	"./nn": 117,
	"./nn.js": 117,
	"./pa-in": 118,
	"./pa-in.js": 118,
	"./pl": 119,
	"./pl.js": 119,
	"./pt": 120,
	"./pt-br": 121,
	"./pt-br.js": 121,
	"./pt.js": 120,
	"./ro": 122,
	"./ro.js": 122,
	"./ru": 123,
	"./ru.js": 123,
	"./sd": 124,
	"./sd.js": 124,
	"./se": 125,
	"./se.js": 125,
	"./si": 126,
	"./si.js": 126,
	"./sk": 127,
	"./sk.js": 127,
	"./sl": 128,
	"./sl.js": 128,
	"./sq": 129,
	"./sq.js": 129,
	"./sr": 130,
	"./sr-cyrl": 131,
	"./sr-cyrl.js": 131,
	"./sr.js": 130,
	"./ss": 132,
	"./ss.js": 132,
	"./sv": 133,
	"./sv.js": 133,
	"./sw": 134,
	"./sw.js": 134,
	"./ta": 135,
	"./ta.js": 135,
	"./te": 136,
	"./te.js": 136,
	"./tet": 137,
	"./tet.js": 137,
	"./tg": 138,
	"./tg.js": 138,
	"./th": 139,
	"./th.js": 139,
	"./tl-ph": 140,
	"./tl-ph.js": 140,
	"./tlh": 141,
	"./tlh.js": 141,
	"./tr": 142,
	"./tr.js": 142,
	"./tzl": 143,
	"./tzl.js": 143,
	"./tzm": 144,
	"./tzm-latn": 145,
	"./tzm-latn.js": 145,
	"./tzm.js": 144,
	"./ug-cn": 146,
	"./ug-cn.js": 146,
	"./uk": 147,
	"./uk.js": 147,
	"./ur": 148,
	"./ur.js": 148,
	"./uz": 149,
	"./uz-latn": 150,
	"./uz-latn.js": 150,
	"./uz.js": 149,
	"./vi": 151,
	"./vi.js": 151,
	"./x-pseudo": 152,
	"./x-pseudo.js": 152,
	"./yo": 153,
	"./yo.js": 153,
	"./zh-cn": 154,
	"./zh-cn.js": 154,
	"./zh-hk": 155,
	"./zh-hk.js": 155,
	"./zh-tw": 156,
	"./zh-tw.js": 156
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import axios from 'axios'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'question',
  props: ['brandColor', 'company'],
  components: {
    vueSlider: __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a
  },
  created: function created() {
    var _this = this;

    this.setValue();
    if (localStorage.getItem('surveyType') === 'company' && this.getObj('company')) {
      this.img = this.getObj('company').logo;
    }

    if (localStorage.getItem('surveyType') === 'customer') {
      this.maxQuestion = 1;
    }

    if (this.getObj('surveySubmit') === true) {
      this.options.disabled = true;
    }
    // When the page is transitioning on load, the slider component breaks. This event waits for the parent to stop transitioning before reloading the component
    this.$parent.$on('refresh-slider', function () {
      _this.$refs.slider.refresh();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.$off('refresh-slider');
  },
  data: function data() {
    return {
      customerSurvey: false,
      img: '',
      disabled: false,
      qNo: 1,
      maxQuestion: 12,
      value: 5,
      customerQuetion: ['On a scale of zero to ten, how confidently would you recommend ' + this.company + ' to a friend or colleague?'],
      questions: ['My role contributes directly to the organisation\'s success.', 'My immediate team has the skills required to deliver to the organisation\'s goals.', 'My manager has the expertise required to enable me to be successful in my role.', 'I am confident in the ability of our Senior Leaders to drive our organisation\'s success.', 'I understand the strategic direction of the organisation and its goals for the future.', 'I am confident in my organisation\'s ability to successfully adapt and change.', 'The different parts of the organisation work well together to achieve the organisation\'s goals.', 'My organisation offers me the development required to continue enhancing my skills.', 'Being part of this organisation positively supports my career aspirations.', 'The communication within my organisation is transparent and efficient.', 'I would recommend this organisation as a great place to work.', 'Overall, I have confidence in the organisation\'s future success.'

      // 'Most days, I see positive results because of my contribution.',
      // 'The people I work with take accountability for and ownership of the results they produce.',
      // 'My manager provides me with the tools, training and guidance I need to effectively perform my job.',
      // 'Senior leaders in my organisation have the experience, skills and abilities to contribute positively to our overall success.',
      // 'I would recommend this organisation as a great place to work.',
      // 'My organisation in its current state adapts well to change.',
      // 'My organisation offers me opportunities to learn and progress in my career.',
      // 'There are no barriers to open and efficient communication in my organisation.'
      ],
      options: {
        eventType: 'auto',
        width: 'auto',
        height: 15,
        dotSize: 30,
        tooltip: false,
        min: 0,
        max: 10,
        disabled: false,
        sliderStyle: {
          backgroundColor: this.brandColor,
          boxShadow: 'none'
        }
      }
    };
  },

  methods: {
    afterEnter: function afterEnter() {
      var _this2 = this;

      this.$nextTick(function () {
        return _this2.$refs.slider.refresh();
      });
    },
    getQuestion: function getQuestion() {
      if (localStorage.getItem('surveyType') === 'customer') {
        this.customerSurvey = true;
        return this.customerQuetion[this.qNo - 1].replace('[brand/organisation]', this.getObj('company').name);
      } else {
        return this.questions[this.qNo - 1];
      }
    },
    getObj: function getObj(name) {
      var obj = localStorage.getItem(name);
      return JSON.parse(obj);
    },
    setValue: function setValue() {
      var obj = this.getObj('user-data');
      this.value = obj['ans_' + this.qNo];
    },
    backQuestion: function backQuestion() {
      this.qNo--;
      this.setValue();
    },
    nextQuestion: function nextQuestion() {
      var obj = localStorage.getItem('user-data');
      var data = JSON.parse(obj);
      data['ans_' + this.qNo] = this.value;
      localStorage.setItem('user-data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      if (this.qNo === this.maxQuestion) {
        var params = {};
        if (localStorage.getItem('surveyType') !== 'generic') {
          params = { link: this.$route.params.link };
        }
        this.$router.push({ name: 'submit', params: params });
      } else {
        this.qNo++;
        this.setValue();
      }

      // this.$router.push({name: 'question', params: { link: this.$route.params.link, qno: this.$route.params.qno++ }})
    }
  },
  computed: {
    progressPercent: function progressPercent() {
      return this.qNo / this.maxQuestion * 100;
    }
  }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 w-full text-center"},[(_vm.generic)?_c('div',[_c('h1',{staticClass:"text-xl mb-2"},[_vm._v("Thank you for completing the survey.")]),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('p',{staticClass:"mb-3"},[_vm._v("Your average score was "),_c('b',[_vm._v(_vm._s(_vm.calcAvg(_vm.avg)))]),_vm._v(". The current national average for Employee Confidence is "),_c('b',[_vm._v(_vm._s(_vm.calcAvg(_vm.globalAvg)))]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Your score out of 10 provides an indication of your confidence in your organisation’s potential for current and future success.")])]),_vm._v(" "),_c('div',{staticClass:"py-4 mx-auto",staticStyle:{"max-width":"200px"}},[_c('mini-bar-chart',{attrs:{"chartData":_vm.pieData,"options":_vm.pieOptions}})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"pt-8"},[_c('button',{staticClass:"mx-2 text-white rounded px-8 py-2 uppercase tracking-wide font-semibold",style:({backgroundColor: _vm.brandColor}),attrs:{"type":"button"},on:{"click":_vm.goNext}},[_vm._v("Go Back")])])]):_c('div',[_c('h1',{staticClass:"text-xl mb-2"},[_vm._v("Thank you for completing the survey.")]),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('p',{staticClass:"mb-3"},[_vm._v("Your average score was "),_c('b',[_vm._v(_vm._s(_vm.calcAvg(_vm.avg)))]),_vm._v(". The current national average for Employee Confidence is "),_c('b',[_vm._v(_vm._s(_vm.calcAvg(_vm.globalAvg)))]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Your score out of 10 provides an indication of your confidence in your organisation’s potential for current and future success.")])]),_vm._v(" "),_c('div',{staticClass:"py-4 mx-auto",staticStyle:{"max-width":"200px"}},[_c('mini-bar-chart',{attrs:{"chartData":_vm.pieData,"options":_vm.pieOptions}})],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mt-4"},[_c('p',{staticClass:"mb-3"},[_vm._v("The overall national average score will be updated here in real time, so check back here to see how your Confidence as an employee compares to the rest of the country’s employees participating in this survey process.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mt-8"},[_c('h2',{staticClass:"text-sm"},[_vm._v("CONFIDENTIALITY")]),_vm._v(" "),_c('p',{staticClass:"text-sm text-grey-darker"},[_vm._v("K3 Consulting will not disclose your information to any party outside of this process. The information you provide will be stored securely by K3 Consulting with appropriately restricted access. By completing this survey and submitting it you are acknowledging and agreeing that you are supplying personal information for the purposes of creating an Employee Confidence benchmark and these results can be released to K3 Consulting Ltd for this purpose. For more information on K3’s Privacy Policy, go to: "),_c('a',{staticClass:"underline text-blue hover:text-blue-darker focus:text-blue-darker",attrs:{"target":"_blank","href":" https://cdn2.hubspot.net/hubfs/3417663/Privacy%20and%20Confidentiality%20Policy%20-%20Employee%20Confidence%202020.pdf"}},[_vm._v("Privacy & Confidentiality Policy 2020")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mt-4"},[_c('p',{staticClass:"mb-3"},[_vm._v("The overall national average score will be updated here in real time, so check back here to see how your Confidence as an employee compares to the rest of the country’s employees participating in this survey process.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mt-8"},[_c('h2',{staticClass:"text-sm"},[_vm._v("CONFIDENTIALITY")]),_vm._v(" "),_c('p',{staticClass:"text-sm text-grey-darker"},[_vm._v("Your score will contribute to your organisation’s total average score. The organisation cannot see your individual results. K3 Consulting will not disclose your information to any party outside of this process. The information you provide will be stored securely by K3 Consulting with appropriately restricted access. By completing this survey and submitting it you are acknowledging and agreeing that you are supplying personal information for the purposes of creating an Employee Confidence benchmark and these results can be released to K3 Consulting Ltd for this purpose. For more information on K3’s Privacy Policy, go to: "),_c('a',{staticClass:"underline text-blue hover:text-blue-darker focus:text-blue-darker",attrs:{"target":"_blank","href":" https://cdn2.hubspot.net/hubfs/3417663/Privacy%20and%20Confidentiality%20Policy%20-%20Employee%20Confidence%202020.pdf"}},[_vm._v("Privacy & Confidentiality Policy 2020")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'thankyou',
  created: function created() {
    if (localStorage.getItem('surveyType') === 'company') {
      this.img = this.getObj('company').logo;
    }
  },
  data: function data() {
    return {
      img: ''
    };
  },

  methods: {
    getObj: function getObj(name) {
      var obj = localStorage.getItem(name);
      return JSON.parse(obj);
    },
    backQuestion: function backQuestion() {
      this.$router.push({ name: 'question', params: { link: this.$route.params.link, qno: 1 } });
    }
  }
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerFinal_vue__ = __webpack_require__(157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a55ec17_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerFinal_vue__ = __webpack_require__(262);
function injectStyle (ssrContext) {
  __webpack_require__(261)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerFinal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a55ec17_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerFinal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 w-full text-center"},[_c('div',[_c('h1',{staticClass:"text-xl mb-2"},[_vm._v("Thank you for completing the survey.")]),_vm._v(" "),_c('p',{staticClass:"text-left"},[_vm._v("We're always looking to improve our service so thank you for your feedback. If you have any other feedback or issues you'd like to raise with us, please don't hesitate to get in touch. Thank you!")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Submit_vue__ = __webpack_require__(158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6424e653_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Submit_vue__ = __webpack_require__(265);
function injectStyle (ssrContext) {
  __webpack_require__(264)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Submit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6424e653_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Submit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 264:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 text-center w-full"},[_c('h1',[_vm._v("Survey complete!")]),_vm._v(" "),_c('div',{staticClass:"font-weight-thin my-2 display-2"},[_vm._v("Do you want to submit your survey now?")]),_vm._v(" "),_c('div',{staticClass:"py-8"},[_c('button',{staticClass:"mx-2 rounded px-8 py-2 uppercase tracking-wide font-semibold",style:({color: _vm.brandColor}),attrs:{"type":"button"},on:{"click":_vm.backQuestion}},[_vm._v("Go Back")]),_vm._v(" "),_c('button',{staticClass:"mx-2 text-white rounded px-8 py-2 uppercase tracking-wide font-semibold ",style:({backgroundColor: _vm.brandColor}),attrs:{"id":"finish-btn","type":"button"},on:{"click":_vm.submitSurvey}},[_vm._v("Submit")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_charts_MiniBarChart__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'final',
  components: { MiniBarChart: __WEBPACK_IMPORTED_MODULE_0__components_charts_MiniBarChart__["a" /* default */] },
  props: ['brandColor'],
  created: function created() {
    var _this = this;

    var obj = localStorage.getItem('user-data');
    var data = JSON.parse(obj);

    this.avg = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].reduce(function (p, c) {
      return data['ans_' + c] + p;
    }, 0) / 12;
    if (localStorage.getItem('surveyType') !== 'generic') {
      this.img = this.getObj('company').logo;
    }

    if (this.getObj('surveySubmit') === true) {
      this.surveySubmitted = true;
    }
    var param = 'generic';
    if (localStorage.getItem('surveyType') !== 'generic') {
      param = this.getObj('company').link;
      this.generic = false;
      // param = this.$route.params.link
    }
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://staging.server.employeeconfidence.nz/api" + '/survey/avg/' + localStorage.getItem('surveyType') + '/' + param).then(function (response) {
      _this.globalAvg = response.data.avg;
      localStorage.setItem('globalAvg', _this.globalAvg);
    }).catch(function (e) {
      console.log(e);
    });
  },
  data: function data() {
    return {
      img: '',
      avg: 0,
      globalAvg: 0,
      surveySubmitted: false,
      generic: true,
      pieOptions: {
        tooltips: {
          enabled: false
        },
        responsive: true,
        legend: { display: false },
        animation: {
          duration: 3000
        },
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              max: 10
            }
          }]
        }
      }
    };
  },

  methods: {
    calcAvg: function calcAvg(avg) {
      var surveyType = localStorage.getItem('surveyType');
      if (surveyType === 'customer') {
        return parseFloat((avg * 8).toFixed(2));
      } else {
        return parseFloat(avg.toFixed(2));
      }
    },
    getObj: function getObj(name) {
      var obj = localStorage.getItem(name);
      return JSON.parse(obj);
    },
    backQuestion: function backQuestion() {
      var param = { qno: 1 };
      if (localStorage.getItem('surveyType') !== 'generic') {
        param = { link: this.$route.params.link, qno: 1 };
      }
      this.$router.push({ name: 'question', params: param });
    },
    goNext: function goNext() {
      var surveyType = localStorage.getItem('surveyType');
      var param = { link: this.$route.params.link };
      console.log(surveyType, param);
      localStorage.clear();
      if (surveyType === 'generic') {
        this.$router.push('/generic');
      } else if (surveyType === 'customer') {
        this.$router.push('/customer/' + param.link);
      } else {
        this.$router.push('/survey/' + param.link);
      }
    }
  },
  computed: {
    pieData: function pieData() {
      var arr = {
        labels: ['You', 'National'],
        datasets: [{
          backgroundColor: ['#ef4a47', '#8f2c2b'],
          hoverBorderWidth: 0,
          data: [this.calcAvg(this.avg), this.calcAvg(this.globalAvg)]
        }]
      };
      return arr;
    }
  }
});

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MiniBarChart_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(207)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MiniBarChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(208);

// CommitChart.js

// Chart.defaults.global.defaultFontFamily = 'Muli'
// Chart.defaults.global.defaultFontSize = 14

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* mixins */].reactiveProp],
  props: ['chartData', 'options'],
  mounted: function mounted() {
    // Overwriting base render method with actual data.
    this.renderChart(this.chartData, this.options);
  }
});

/***/ })

},[159]);


// WEBPACK FOOTER //
// static/js/app.6e146505efd07e723453.js